/* eslint-disable */
import { EditOutlined, ExportOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Layout, message, notification, Row, Typography } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
// import classNames from 'classnames'
/* eslint-disable */

// Svg Icon
import { ReactComponent as ExportIcon } from '../../../assets/export.svg'

// Local Files
import HeaderLayout from '../../../layouts/HeaderLayout'
import ModalLayout from '../components/ModalLayout'
import FilteredData from './FilteredData'
import Filters from './Filters'
// Constants
import { QUERY_ACTIONS } from '../components/Constants'
// Context
import { useAuthState } from '../../../contexts/AuthContext'
import {
  setFields,
  setIsLoading,
  setSavedSearchVal,
  useQueryActions,
  useQuerysDispatch,
  useQuerysState
} from '../CandidateContext/SearchQueryContext'
// Styles
import classNames from 'classnames'
import { matchPath, useLocation } from 'react-router'
import { ButtonsWrapper } from '../../../components/theme-components'
import Candidates from '../SearchCandidate'
import getSearchFilters from './Filters/helpers/getSearchFilters'
import './searchedCandidates.css'
import SimpleSearchFilter from './SimpleSearchFilter/SimpleSearchFilter'

const { Title } = Typography
export default function FilteredCandidates({ match }) {
  // State
  const [isOpen, setIsOpen] = React.useState(false)
  const [updateModal, setUpdateModal] = React.useState(false)
  // const [isSave, setIsSave] = React.useState(false)
  const [advancedSearchVal, setAdvanceSearchVal] = React.useState(false)
  const [savedSearch, setSavedSearch] = React.useState(false)
  const { jobkey } = match.params
  const location = useLocation()

  // Context
  const actions = useQueryActions()
  const dispatch = useQuerysDispatch()
  const { searchApiObj } = useQuerysState()
  const { user } = useAuthState()
  const { candidatesFilters, SelectedCandidates, isLoading, searchedCandidates } = useQuerysState()

  // Refs
  const DownloadRef = React.useRef()

  const simpleSearchPath = matchPath(location.pathname, {
    path: '/simplesearch',
    exact: true,
    strict: false
  })
  const savedSearchPath = matchPath(location.pathname, {
    path: '/candidates/:jobkey',
    exact: true,
    strict: false
  })

  const getActiveSearchQuery = async () => {
    try {
      await actions.jobPreview(jobkey)
      await actions.getSearchedCandidates(jobkey)
    } catch (e) {
      console.log(e)
    }
  }

  const HeaderTitle = (isOpen, setIsOpen, candidatesFilters) => {
    const updateSearch = () => {
      // setIsOpen(!isOpen)
      setUpdateModal(!updateModal)
    }
    const handleOk = (name, desc) => {
      const reqHeader = candidatesFilters
      if (reqHeader) {
        const annotations = JSON.parse(reqHeader.searchJson)
        reqHeader.annotations = annotations
        reqHeader.description = desc || 'Description'
        reqHeader.name = name
        actions.updateJob(reqHeader)
      }
      setIsOpen(false)
      setUpdateModal(!updateModal)
    }
    return (
      <Row>
        {candidatesFilters?.name ? (
          <Title level={4} className="filteredDataTitle">
            {candidatesFilters?.name}
            <EditOutlined onClick={updateSearch} style={{ marginLeft: '6px' }} />
          </Title>
        ) : (
          ''
        )}
        {updateModal && (
          <ModalLayout
            isOpen={true}
            handleOk={handleOk}
            setIsopen={setUpdateModal}
            isDescription={false}
            isLoading={isLoading}
            modalBody={QUERY_ACTIONS.EDIT}
            updateSearch={candidatesFilters}
          />
        )}
      </Row>
    )
  }

  React.useEffect(() => {
    setAdvanceSearchVal(false)
    if (!simpleSearchPath) {
      getActiveSearchQuery()
    }
  }, [])

  const handleExportCandidates = async (e) => {
    dispatch(setIsLoading(true))
    let exportLoader
    try {
      const payload = {
        resultIds: SelectedCandidates,
        resultSetId: searchedCandidates?.resultSetId
      }
      exportLoader = message.loading('Creating CSV..', 0)
      setTimeout(exportLoader, 1000)
      const exportCandidates = await actions.exportCandidates(payload) // Export Api
      const blob = new Blob([exportCandidates.data], { type: 'octet/stream' })
      const url = window.URL.createObjectURL(blob)
      DownloadRef.current.href = url
      DownloadRef.current.download = 'export-candidates.csv'
      await DownloadRef.current.click()
      const exportedLoader = message.success(`${SelectedCandidates.length} rows downloaded`, 0)
      setTimeout(exportedLoader, 2000)
      dispatch(setIsLoading(false))
      dispatch(setFields({ SelectedCandidates: [], setIsLoading: false }))
      window?.analytics?.track('exported selected', {
        search_id: jobkey
      })

      // }
    } catch (e) {
      // setTimeout(() => {
      // message.error({ content: 'Something went wrong' })
      notification.error({
        placement: 'topLeft',
        message: 'You do not have any credits remaining. Please contact your Account Manager.'
      })
      // }, 2000)
      dispatch(setIsLoading(false))
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  const handleOk = () => {
    setIsOpen(false)
    handleExportCandidates()
  }

  const exportCandidate = () => {
    const exportCandidateModal = () => {
      if (SelectedCandidates.length < 1 || isLoading)
        return setTimeout(message.warning('Select any row to export..', 0), 1000)
      else if (user?.showConsumptionPopups) {
        setIsOpen(true)
      } else {
        handleExportCandidates()
      }
    }

    return (
      <>
        <a href="#" ref={DownloadRef} />
        <Button
          type="primary"
          id="export-selected"
          icon={<ExportOutlined />}
          onClick={exportCandidateModal}
        >
          Export Selected
        </Button>
      </>
    )
  }

  const FilteredDataStats = () => {
    return (
      <Row className={classNames(isLoading ? 'disabled-stats candidate-stats' : 'candidate-stats')}>
        <Row>
          <span>Very Qualified</span>
          <span> {searchedCandidates?.group1} </span>
        </Row>
        <span className="stat-divider" />
        <Row>
          <span> Qualified</span>
          <span> {searchedCandidates?.group2} </span>
        </Row>
        <span className="stat-divider" />
        <Row>
          <span> Semi Qualified</span>
          <span> {searchedCandidates?.group3} </span>
        </Row>
        <span className="stat-divider" />
        <Row>
          <span> Least Qualified</span>
          <span> {searchedCandidates?.group4} </span>
        </Row>
      </Row>
    )
  }

  return (
    <HeaderLayout
      title={
        simpleSearchPath ? (
          <div className="saving-search-container">
            <span>Search Results</span>
            <div
              className={isLoading ? 'disable-save-search' : 'saving-search'}
              onClick={() => dispatch(setSavedSearchVal(true))}
            >
              <SaveOutlined style={{ marginRight: '8px' }} />
              <span>Save this search</span>
            </div>
          </div>
        ) : (
          HeaderTitle(isOpen, setIsOpen, candidatesFilters)
        )
      }
      extra={
        simpleSearchPath ? (
          <div className="saving-search-container">
            <div
              className={isLoading ? 'disable-save-search' : 'saving-search'}
              onClick={() => setSavedSearch(true)}
            >
              <SearchOutlined style={{ marginRight: '8px' }} />
              <span>View Saved Searches</span>
            </div>
            <Candidates setSavedSearch={setSavedSearch} savedSearch={savedSearch} />
          </div>
        ) : (
          ''
        )
      }
      isFooterHide={true}
    >
      <Layout id="searchedCandidatesLayout">
        {savedSearchPath && <Filters />}
        {!savedSearchPath && simpleSearchPath && <Filters />}
        <FilteredData extra={exportCandidate()} advancedSearchVal={advancedSearchVal} />
      </Layout>

      {isOpen && (
        <ModalLayout
          isOpen={true}
          handleOk={handleOk}
          setIsopen={setIsOpen}
          isLoading={isLoading}
          modalBody={QUERY_ACTIONS.EXPORT_CANDIDATES}
        />
      )}
    </HeaderLayout>
  )
}

FilteredCandidates.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      jobkey: PropTypes.string
    })
  })
}
